var POSTSFILTER = (function() {
  function init() {
    const filter = document.querySelector(".b-all-posts__filter select");

    filter.addEventListener("change", function() {
      // Create URL object from current url
      const url = new URL(window.location.href);

      // Filter /page/x from pathname
      const regex = /\/page\/\d+/g;
      const newPathname = url.pathname.replace(regex, "");
      url.pathname = newPathname;

      // Set filter query parameter
      url.searchParams.set("filter", filter.value);

      // Go to url
      window.location.href = url;
    });
  }

  return {
    init: init,
  };
})();
